export default "__VITE_ASSET__B1Yt_joP__"